import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation, useQueryClient } from 'react-query';

import { atmosConstants } from '..';

export const useAtmosConfigDelete = () => {
  const qc = useQueryClient();

  return useMutation(
    async (id?: number | null) => {
      const res = await $api?.delete(
        stringifyUrl({
          url: '/v1/atmos/config',
          query: {
            cashId: id
          }
        })
      );

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([atmosConstants.queryKeys.ATMOS_CONFIG]);
      }
    }
  );
};
